import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { AlertController, LoadingController, MenuController } from '@ionic/angular';
import { ChatService } from 'src/app/services/chat.service';

import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
  loginForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private menuCtrl: MenuController,
    private alertController: AlertController,
    private loadingController: LoadingController,
    private userService: UserService,
    private chatService: ChatService
  ) { }

  ngOnInit() {
    this.menuCtrl.enable(false);
    this.loginForm = this.fb.group({
      email: ['', []],
      password: ['', []]
    });
  }

  async signIn() {
    let errorMsg = '';
    if (!this.loginForm.value.email || this.loginForm.value.email === '') {
      errorMsg = 'Debe ingresar un correo electrónico';
    }
    else if (!this.loginForm.value.password || this.loginForm.value.password === '' || this.loginForm.value.password.length < 6) {
      errorMsg = 'Debe ingresar contraseña, la misma debe contener al menos 6 caractéres';
    }

    if (errorMsg) {
      const alert = await this.alertController.create({
        header: ':(',
        message: errorMsg,
        buttons: ['OK'],
      });

      await alert.present();
      return false;
    }

    const loading = await this.loadingController.create();
    await loading.present();

    this.userService
      .signIn(this.loginForm.value)
      .then(
        async (res) => {

          console.log('signIn RES:', res);
          loading.dismiss();

          //this.router.navigateByUrl('/home', { replaceUrl: true });
        },
        async (err) => {
          loading.dismiss();
          const alert = await this.alertController.create({
            header: ':(',
            message: err.message,
            buttons: ['OK'],
          });

          await alert.present();
        }
      );
  }

  async resetPassword() {
    let errorMsg = '';
    if (!this.loginForm.value.email || this.loginForm.value.email === '') {
      errorMsg = 'Debe ingresar un correo electrónico';
    }
    
    if (errorMsg) {
      const alert = await this.alertController.create({
        header: ':(',
        message: errorMsg,
        buttons: ['OK'],
      });

      await alert.present();
      return false;
    }

    const loading = await this.loadingController.create();
    await loading.present();

    this.userService
      .resetPassword(this.loginForm.value.email)
      .then(
        async (res) => {

          console.log('RESET PASS RESULT:', res);
          loading.dismiss();

          const alert = await this.alertController.create({
            header: 'Revisa tu correo',
            message: 'Hemos enviado un enlace para cambiar la contraseña',
            buttons: ['OK'],
          });

          await alert.present();

          //this.router.navigateByUrl('/home', { replaceUrl: true });
        },
        async (err) => {
          loading.dismiss();
          const alert = await this.alertController.create({
            header: ':(',
            message: err.message,
            buttons: ['OK'],
          });

          await alert.present();
        }
      );
  }

  submitOnEnter(e){
    if (e.keyCode === 13) {
      this.signIn();
    }
  }
}
